import * as React from 'react';
import { RemoveIcon } from 'elc-icons';
import { Button } from 'elc-buttons';
import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';

const StyledFilterButton = styled(Button)`
    margin-right: ${ContentSpacing.space16};
    margin-bottom: ${ContentSpacing.space6};
    cursor: pointer;

    [dir='rtl'] & {
        margin-right: 0;
        margin-left: ${ContentSpacing.space6};
    }
`;

const StyledRemoveIcon = styled(RemoveIcon)`
    width: 8px;
    cursor: pointer;
    display: inline-block;
    margin-left: ${ContentSpacing.space6};

    [dir='rtl'] & {
        margin: {
            right: ${ContentSpacing.space6};
            left: 0;
        }
    }
`;

export interface IFilterItemWrapper {
    onClick(): void;
    ariaLabel: string;
    className?: string;
}

export class FilterItemWrapper extends React.Component<IFilterItemWrapper> {
    render() {
        return (
            <StyledFilterButton
                onClick={this.props.onClick}
                className={this.props.className}
                aria-label={this.props.ariaLabel}
            >
                {this.props.children}
                <StyledRemoveIcon />
            </StyledFilterButton>
        );
    }
}
